<template>
  <transition name="translate">
    <div v-if="isActive" class="carousel-content-item">
      <h2 class="carousel-slide-title" v-html="content.title"></h2>
      <div class="carousel-slide-link">
        <a :href="content.link.url">
          {{ content.link.text }}
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    content: Object,
    currentSlide: Number,
    index: Number
  },
  computed: {
    isActive() {
      return this.currentSlide === this.index
    }
  }
}
</script>

<style lang="scss">
.carousel-content-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  perspective: calc(100vh - 204px);
}

.carousel-content-item {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(aqua, 0.5);

  transform: translateZ(200px);
}

.translate-enter-active,
.translate-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.translate-enter {
  opacity: 0;
  transform: translateZ(0);
}

.translate-leave-to {
  opacity: 0;
  transform: translateZ(1000px);
}

// .translate-enter, .translate-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
</style>
